module.exports = __webpack_public_path__ + "static/media/momocutscene.de88c9e0.jpg";